import { Component, OnInit } from '@angular/core';

import { HeaderService } from '../header/header.service';

@Component({
  selector: 'nec-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class NecFooterComponent implements OnInit {

  terms: any[] = [
    {
      name: 'éç§æ¿ç­',
      url: 'https://cdn.512ks.cn/privacy/local/privacy.html'
    }
  ]

  constructor(private headerService: HeaderService) {
  }

  ngOnInit(): void {
    this.terms = this.checkTermsUrl(this.terms);
  }

  go2Url(url: string): void {
    window.open(url);
  }

  private checkTermsUrl(terms: any[]): any[] {
    let url = location.origin || location.href;
    let env = 'local';
    if (url.indexOf('512ks') >= 0) {
      if (url.indexOf('dev') >= 0) {
        env = 'dev';
      } else if (url.indexOf('rls') >= 0) {
        env = 'rls';
      } else if (url.indexOf('hfx') >= 0) {
        env = 'hfx';
      } else if (url.indexOf('www') >= 0) {
        env = 'prd';
      }
    }
    terms.forEach(term => {
      term.url = term.url.replace('local', env);
    })
    return terms;
  }

  updateActiveModule() {
    this.headerService.updateActiveModule('');
  }
}
